import { Formula } from '../types/package';

export function getDisplayPrice(formula: Formula): number {
  if (formula.priceType === 'PER_PERSON' && formula.perPersonPrice) {
    return formula.perPersonPrice;
  }
  
  if (formula.roomPrices) {
    const prices = Object.values(formula.roomPrices).filter(price => price > 0);
    return prices.length > 0 ? Math.min(...prices) : 0;
  }

  return 0;
}

export function formatPrice(formula: Formula): string {
  const price = getDisplayPrice(formula);
  const formattedPrice = price.toLocaleString('fr-DZ');
  
  if (formula.priceType === 'PER_PERSON') {
    return `${formattedPrice} DA par personne`;
  } else {
    return `À partir de ${formattedPrice} DA par personne (selon type de chambre)`;
  }
} 